import { create } from 'zustand';

interface AppState {
  // 状态
  isLoading: boolean;
  toastMessage: string | null;
  
  // 操作
  setLoading: (loading: boolean) => void;
  showToast: (message: string) => void;
  hideToast: () => void;
}

/**
 * 应用全局状态管理
 */
export const useAppStore = create<AppState>((set) => ({
  // 初始状态
  isLoading: false,
  toastMessage: null,

  // 设置加载状态
  setLoading: (loading: boolean) => {
    set({ isLoading: loading });
  },

  // 显示提示消息
  showToast: (message: string) => {
    set({ toastMessage: message });
    // 3秒后自动隐藏
    setTimeout(() => {
      set({ toastMessage: null });
    }, 3000);
  },

  // 隐藏提示消息
  hideToast: () => {
    set({ toastMessage: null });
  },
}));
